import EyeInvisibleOutlined from '@ant-design/icons/lib/icons/EyeInvisibleOutlined'
import EyeTwoTone from '@ant-design/icons/lib/icons/EyeTwoTone'
import {Button, Input} from 'antd'
import {auth_register_Api} from 'apis'
import ApiInfoForm from 'components/form/ApiInfoForm'
import FieldDecorator from 'components/form/FieldDecorator'
import React from 'react'
import * as Yup from 'yup'
import useTranslate from '../../modules/local/useTranslate'
import './RegisterForm.css'
import {renderIfElse} from "../Shared";

export const Register = ({
    org_type = undefined, setBack = () => {}
}) => {
    const t = useTranslate()

    return (
        <ApiInfoForm
            apiInfo={auth_register_Api}
            initialValues={{
                email: '',
                name: '',
                password: '',
                confirm_password: '',
                org_type,
                organization_name: null,
                reg_pathname: `${window.location.pathname}${window.location.search}${window.location.hash}`
            }}
            validationSchema={Yup.object().shape({
                name: Yup.string().required(t('required field')),
                email: Yup.string()
                    .email(t('invalid email address'))
                    .required(t('required field')),
                password: Yup.string()
                    .required(t('password required'))
                    .matches(/^\S*$/, t('password must not contain spaces'))
                    .min(8, t('password must have min 8 characters')),
                confirm_password: Yup.string()
                    .required(t('confirm password required'))
                    .matches(/^\S*$/, t('password must not contain spaces'))
                    .oneOf([Yup.ref('password'), null], t('Password and confirm password does not match')),
            })}>
            {(props) => {
                const {
                    values,
                    errors,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    success,
                } = props

                return (
                    renderIfElse(
                        success,
                        <div
                            className="flex flex-col gap-3"
                            style={{
                                display: 'inline-block',
                                padding: '16px 0',
                                color: '#161616',
                            }}>
                            <div className="p-3 flex flex-col background-50 rounded-xl">
                                <div className="text-color-200">
                                    <span>{t('the activation email has been sent to')}</span>
                                    <span className="px-1 font-bold text-secondary-600">
                                        {values.email}.
                                    </span>
                                </div>
                                <div className="text-color-200">
                                    {t('check your email and click on the activation link to complete the registration')}
                                </div>
                            </div>
                            <div className="text-sm italic">
                                {t('attention: please check your activation email in the spam area')}
                            </div>
                        </div>,
                        <form onSubmit={handleSubmit} className="flex flex-col gap-2">
                            <FieldDecorator
                                errors={errors.email}
                                label={org_type ? t('account') : undefined}
                                labelProps={{ className: undefined }}>
                                <Input
                                    size="large"
                                    inputMode="email"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="rounded-md"
                                    type="text"
                                    placeholder={t('email account')}
                                />
                            </FieldDecorator>
                            <FieldDecorator
                                isRequired={true}
                                errors={errors.password}>
                                <Input.Password
                                    size="large"
                                    type="password"
                                    name="password"
                                    className="rounded-md"
                                    value={values.password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder={t('password')}
                                    iconRender={(visible) =>
                                        visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>
                                    }
                                />
                            </FieldDecorator>
                            <FieldDecorator errors={errors.confirm_password}>
                                <Input.Password
                                    size="large"
                                    type="password"
                                    name="confirm_password"
                                    className="rounded-md"
                                    value={values.confirm_password}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder={t('retype password')}
                                    iconRender={(visible) =>
                                        visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>
                                    }
                                />
                            </FieldDecorator>

                            {!!org_type && !isNaN(org_type) ? (
                                <FieldDecorator
                                    errors={errors.name}
                                    label={t('provider name')}
                                    labelProps={{ className: undefined }}>
                                    <Input
                                        size="large"
                                        name="name"
                                        type="text"
                                        value={values.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className="rounded-md"
                                        placeholder={t('enter provider name')}
                                    />
                                </FieldDecorator>
                            ) : (
                                <FieldDecorator
                                    errors={errors.name}
                                    label={t('fullname')}
                                    labelProps={{ className: undefined }}>
                                    <Input
                                        size="large"
                                        name="name"
                                        type="text"
                                        value={values.name}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className="rounded-md"
                                        placeholder={t('Enter your name')}
                                    />
                                </FieldDecorator>
                            )}
                            <div className="pt-1 flex items-center gap-3">
                                <span
                                    onClick={setBack}
                                    className="flex-shrink-0 text-sm text-color-300 hover:text-color-100 cursor-pointer">
                                    ← {t('back')}
                                </span>
                                <Button
                                    onClick={handleSubmit}
                                    color="primary" variant="solid"
                                    size="large"
                                    className="flex-1 font-semibold rounded-md no-text-shadow no-shadow">
                                    {isSubmitting ? t('waiting') : t('register')}
                                </Button>
                            </div>
                        </form>
                    )
                )
            }}
        </ApiInfoForm>
    )
}

export default Register
